<template>
  <div class="box">
    <el-form label-width="120px" class="main-container">
      <div class="mainTitle">报名表预览</div>
      <div v-for="item in formData" :key="item.title" class="formSection">
        <div class="title">{{item.titleName}}</div>
        <div class="formList"> 
          <el-form-item 
            :required="formItem.required"
            :class="formItem.type == 'imageUpload' ||  formItem.type == 'textarea'? 'imgForm' : ''"
            v-for="formItem in item.formList"
            :key="formItem.displayName"
            :label="formItem.displayName"
            v-if="formItem.showInPage==1"
            >
              <form-type :formItem="formItem"/>
          </el-form-item>
        </div>
      </div>
      <div class="footer">
        <el-button round @click="$router.go(-1)">返回</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { subData, formData, typeForm } from "./configData";
import systemApi from "@/http/modules/system";
import FormType from "./components/FormType.vue";
export default {
  components: { FormType },
  name: "ReviewForm",
  data() {
    return {
      formData: [],
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      systemApi.getExtDefConfigListFn({ type: "User" }).then( async ({ data }) => {
        let copyData = JSON.parse(JSON.stringify(formData));
        copyData.forEach((item) => {
          data.forEach((extItem) => {
            if (extItem.title == item.title) {
              extItem.extDefinitionVoList.forEach((formItem) => {
                if (formItem.hasOwnProperty("value") && formItem.value) {
                  formItem["value"] = formItem["value"]
                    .split(",")
                    .map((item) => {
                      return {
                        name: item,
                      };
                    });
                }
                if (formItem.hasOwnProperty("fileBack") && formItem.fileBack) {
                  formItem["fileBack"] = formItem["fileBack"]
                    ? formItem["fileBack"].split(",")
                    : [];
                }
              });
              item.formList = item.formList.concat(extItem.extDefinitionVoList);
            }
          })
        })
        // 此处更新教学点名称 和上传照片的说明
        let { configList } = await this.mixin_getSystemConfig()
        if (configList && configList.length) {
          // 教学点
          let stationConfig = configList.find(item => item.setName == 'stationName')
          if (stationConfig && stationConfig.setValue2) {
            copyData[1].formList.find(item => item.type == 'station').displayName = stationConfig.setValue2
          }
          // 照片说明
          // setName:stuImgCondition
          // setValue:图片大小限制
          // setValue2:图片后缀
          // setShowText:图片说明
          let stuImgCondition = configList.find(item => item.setName == 'stuImgCondition')
          if (stuImgCondition) {
            let imgFormObj = copyData[0].formList.find(item => item.displayName == '照片')
            if (stuImgCondition.setShowText) {
              imgFormObj.remarks = stuImgCondition.setShowText
            }
            if (stuImgCondition.setValue2) {
              imgFormObj.fileBack = stuImgCondition.setValue2.split(',')
            }
            if (stuImgCondition.setValue) {
              imgFormObj.filesize = stuImgCondition.setValue
            }
          }
        }
        let {code : peCode,data : peData} = await systemApi.getPhoneAndEmailConfigFn();
        if (peCode==1 && peData && peData.length) {
          // 手机说明
          let phoneFormObj = copyData[0].formList.find(item => item.displayName == '手机号')
          if (phoneFormObj) {
            let phoneConfig = peData.find(item => item.fieldName == 'phone')
            if (phoneConfig) {
              phoneFormObj.required = phoneConfig.required == 0 ? false : true;
              phoneFormObj.showInPage = phoneConfig.showInPage;
            }
          }
          // 邮箱说明
          let emailFormObj = copyData[0].formList.find(item => item.displayName == '邮箱')
          if (emailFormObj) {
            let emailConfig = peData.find(item => item.fieldName == 'email')
            if (emailConfig) {
              emailFormObj.required = emailConfig.required == 0 ? false : true;
              emailFormObj.showInPage = emailConfig.showInPage;
            }
          }
        }
        this.formData = copyData;
      });
    },
  },
};
</script>

<style lang="less">
.box {
  min-width: 1280px;
  position: relative;
  min-height: 100vh;
  box-sizing: border-box;
  padding-top: 108px;
  background: url('../../../assets/stuImg/pubBg.jpg') no-repeat top center;
  background-size: 100% 360px;
}
.main-container {
  padding: 24px;
  padding-bottom: 0;
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
  width: 1240px;
  margin: 0 auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .mainTitle{
    font-size: 20px;
    font-weight: 500;
    padding-top: 10px;
    padding-bottom: 20px;
    border-bottom: 1px dashed #ddd;
    margin-bottom: 30px;
  }
  .formSection {
    padding: 0 15px;
  }
  .title {
    font-size: 16px;
    font-weight: 500;
    padding-bottom: 20px;
    // border-bottom: 1px dashed #ddd;
    margin-bottom: 30px;
  }
  .formList {
    max-width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
}
.imgForm {
  width: 100%;
}
.footer {
  margin-top: 30px;
  width: calc(100% + 48px);
  position: relative;
  left: -24px;
  background: #fff;
  height: 68px;
  box-shadow: 0px -8px 16px 0px rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 0 8px 8px;
}
</style>